customElements.whenDefined('cart-drawer').then(() => {
  if(customElements.get('vbb-cart-upsell-drawer')) return;
  class VbbCartUpsellDrawer extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');

      this.gwpList = this.getJsonById('gwp-upsells');

      this.sampleList = this.getJsonById('sample-upsells');
      this.pwpList = this.getJsonById('pwp-upsells')

      this.cartItems = this.getJsonById('upsells-cart');

      // Samples
      this.samplesElement = document.querySelector('vbb-cart-samples');
      this.samplesElementJson = this.samplesElement.dataset.samplesJson ? JSON.parse(this.samplesElement.dataset.samplesJson) : [];
      this.sampleBlockIds = this.samplesElementJson.map(item => item.variant?.id).filter(Boolean);

      // GWP
      this.gwpElement = document.getElementById('vbb-cart-gwp-accordion');
      this.gwpElementJson = this.gwpElement.dataset.gwpJson ? JSON.parse(this.gwpElement.dataset.gwpJson) : [];
      this.gwpBlockIds = this.gwpElementJson.map(item => item.variant?.id).filter(Boolean);

      // PWP
      this.pwpElement = document.getElementById('vbb-cart-exclusive-accordion');
      this.pwpActive = this.pwpElement?.dataset.pwpEligible === 'true';
      this.pwpCurrentId = parseInt(this.pwpElement?.dataset.pwpId) || null;

    }

    connectedCallback() {
      const upsellProperties = ['_gwp-upsell', '_sample', '_exclusive-item'];

      const upsellItemsByType = this.extractUpsellItems(this.cartItems, upsellProperties);
      const allowedItems = this.getAllowedItems();
      const invalidItems = this.findInvalidUpsells(upsellItemsByType, allowedItems);
      const keysToRemove = Object.values(invalidItems).flat().map(item => item.key);
      if (keysToRemove.length > 0) {
        this.removeInvalidUpsells(keysToRemove, this.cartDrawer);
      }
    }

    getJsonById(id) {
      const el = document.getElementById(id);
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn(`Invalid JSON in #${id}`, e);
        return [];
      }
    }

    // Filters out items that are not in both the relevant metafield and blocks
    getAllowedItems() {
      // Checks active sample block against sampleList metafield.
      // Filters sampleList to only include items that match the sampleBlockIds.
      // If no active sample blocks, sampleList will be empty.

      let sampleList = this.sampleList.items || [];
      const blockIds = new Set(this.sampleBlockIds);
      const filteredItems = sampleList.filter(item => blockIds.has(item.id));
      sampleList = filteredItems;

      // Gets current GWP items from gwpList metafield. Filters gwpList to only include items that match the gwpCurrentId form the theme block.
      let gwpList = this.gwpList.items || [];
      const gwpBlockIds = new Set(this.gwpBlockIds);
      const gwpFilteredItems = gwpList.filter(item => gwpBlockIds.has(item.id));
      gwpList = gwpFilteredItems ?? [];


      let pwpList = this.pwpList.items || [];
      if (this.pwpActive && this.pwpCurrentId) {
        pwpList = pwpList.filter(item => item.id === this.pwpCurrentId);
      }

      // list length is null for some reason
      if(!this.pwpActive || !this.pwpCurrentId || !this.pwpList.length) {
        pwpList = []
        console.warn('No active PWP items found or PWP is not active.');
      }
      return {
        '_sample': sampleList,
        '_gwp-upsell': gwpList,
        '_exclusive-item': pwpList
      };
    }

    extractUpsellItems(cartItems, props) {
      const result = {
        '_gwp-upsell': [],
        '_sample': [],
        '_exclusive-item': []
      };

      cartItems.forEach(item => {
        if (!item.properties) return;

        props.forEach(prop => {
          if (item.properties.hasOwnProperty(prop) && item.properties[prop]) {
            result[prop].push({
              key: item.key,
              id: item.variant_id || item.id,
              properties: item.properties
            });
          }
        });
      });

      return result;
    }

    findInvalidUpsells(upsellItems, allowedItems) {
      const result = {
        '_sample': [],
        '_gwp-upsell': [],
        '_exclusive-item': []
      };

      Object.keys(upsellItems).forEach(prop => {
        const allowedList = allowedItems[prop] || [];
        const allowedMap = new Map(
          allowedList.map(item => [item.id, item])
        );
        result[prop] = upsellItems[prop].filter(cartItem => {
          const allowedItem = allowedMap.get(cartItem.id);
          return !allowedItem || allowedItem.in_stock === false;
        });
      });

      return result;
    }


    removeInvalidUpsells(lineItemIds, cart) {
      const updates = {};
      lineItemIds.forEach(id => updates[id] = 0);

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates,
          sections: cart.getSectionsToRender().map(section => section.id)
        }),
      })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(res => {
        cart.renderContents(res);
        this.showCartError('Exclusive item no longer available');
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(err => {
        console.error(err);
        this.showCartError(window.cartStrings?.error || 'An error occurred');
      })
      .finally(() => {
        cart.setNotLoading();
      });
    }

    showCartError(message) {
      const errorContainer = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      if (errorContainer) {
        errorContainer.textContent = message;
      }
    }
  }

customElements.define('vbb-cart-upsell-drawer', VbbCartUpsellDrawer);

})
